import {useMutation} from '@apollo/client';
import {noteMutations} from 'api/graphql-queries/notes';
import {settingsMutations} from 'api/graphql-queries/settings';
import {useAlert} from 'hooks/useAlert';
import {ResponseViewModel} from 'models';
import {
    SettingCreateRequest,
    SettingCreateUpdateRequest,
    SettingModel,
    SettingsUpdateRequestModel,
} from 'models/settings';
import {useCallback} from 'react';

export const useUpdateSetting = () => {
    const [update, {data, loading}] = useMutation<
        {updateSettings: SettingModel[]},
        {input: SettingsUpdateRequestModel}
    >(settingsMutations.UPDATE_SETTINGS);
    return {
        updateSetting: update,
        updateSettingLoading: loading,
        updateSettingResponse: data?.updateSettings,
    };
};
//create settings
export const useCreateSetting = () => {
    const [create, {data, loading}] = useMutation<{createSettings: SettingModel[]}, {input: SettingCreateRequest}>(
        settingsMutations.CREATE_SETTINGS,
    );
    return {
        createSetting: create,
        createSettingLoading: loading,
        createSettingResponse: data?.createSettings,
    };
};

export const useCreateUpdateSetting = () => {
    const [createUpdate, {data, loading}] = useMutation<
        {createUpdateSettings: SettingModel[]},
        {input: SettingCreateUpdateRequest[]}
    >(settingsMutations.CREATE_UPDATE_SETTINGS);
    return {
        createUpdate,
        createUpdateLoading: loading,
        createUpdateResponse: data?.createUpdateSettings,
    };
};

export const useRemoveSetting = () => {
    const {invokeAlert} = useAlert();
    const [remove, {data, loading}] = useMutation<{removeSetting: ResponseViewModel<string>}, {input: string}>(
        settingsMutations.REMOVE_SETTING,
    );

    const removeSetting = useCallback(
        (id: string) => {
            remove({
                variables: {input: id},
            }).catch(error => {
                invokeAlert(error?.message ?? 'Failed to remove setting');
            });
        },
        [remove],
    );

    return {
        removeSetting,
        removeSettingLoading: loading,
        removeSettingResponse: data?.removeSetting,
    };
};
